/**
 * @file Hauptanwendung.
 * @author <a href="mailto:heiko.pfefferkorn@ifabrik.de">Heiko Pfefferkorn</a>
 * @copyright i-fabrik GmbH 2019
 * @requires jquery
 */

/* global $:true */
/* global Array:true */
/* global document:true */
/* global Main:true */
/* global navigator: true */
/* global Object:true */
/* global parseFloat: true */
/* global RegExp: true */
/* global window:true */
/* global PageConf:true */
/* global PageTranslations:true */
/* global Swiper:true */

var DATA_KEY     = 'isp',
	EVENT_KEY    = '.' + DATA_KEY,
	DATA_API_KEY = '.data-api',
	EVENT        = {
		'BLUR'   : 'blur' + EVENT_KEY,
		'CLICK'  : 'click' + EVENT_KEY,
		'CHANGE' : 'change' + EVENT_KEY,
		'FOCUS'  : 'FOCUS' + EVENT_KEY,
		'GENERAL': 'general' + EVENT_KEY,
		'RESIZE' : 'resize' + EVENT_KEY,
		'SCROLL' : 'scroll' + EVENT_KEY,
		'SUBMIT' : 'submit' + EVENT_KEY,
		'KEYUP'  : 'keyup' + EVENT_KEY,
		'KEYDOWN': 'keydown' + EVENT_KEY,
		'ON'     : 'on' + EVENT_KEY,
		'OFF'    : 'off' + EVENT_KEY,
		'IN'     : 'in' + EVENT_KEY,
		'OUT'    : 'out' + EVENT_KEY,
		'SHOW'   : 'show' + EVENT_KEY,
		'HIDE'   : 'hide' + EVENT_KEY
	},
	Page,
	PageInstance,
	PageBlocker,
	OverlayPanel;

// Auf Vorhandensein von `[].isArray()` prüfen.
if (!Array.isArray)
{
	Array.isArray = function(vArg) {
		'use strict';

		return Object.prototype.toString.call(vArg) === "[object Array]";
	};
}

/**
 * Element auf Sichtbarkeit im Viewport prüfen.
 *
 * @example
 * $(myElement).inViewport();
 * // true || false
 *
 * @param {Object} [o] - Optionen.
 *
 * @returns {boolean}
 */
$.fn.inViewport = function(o) {
	'use strict';

	var params  = $.extend({
			direction: 'v'//, // v, x or both
			// offset   : 0
		}, o || {}),
		rect    = $(this)[0].getBoundingClientRect(),
		wH      = (window.innerHeight || document.documentElement.clientHeight),
		wW      = (window.innerWidth || document.documentElement.clientWidth),
		vInView = (rect.top <= wH) && ((rect.top + rect.height) >= 0),
		hInView = (rect.left <= wW) && ((rect.left + rect.width) >= 0),
		res     = false;

	if (params.direction === 'v')
	{
		res = vInView;
	}
	else if(params.direction === 'h')
	{
		res = hInView;
	}
	else
	{
		res = (vInView && hInView);
	}

	return res;
};

/**
 * Prüfung auf unterstützte Eigenschaften.
 *
 * @param {string} prop
 *
 * @returns {boolean}
 */
window.hasSupport = function(prop) {
	'use strict';

	var $el     = document.createElement('span'),
		elStyle = $el.style,
		p       = (typeof prop !== 'undefined') ? prop : '',
		res;

	/*if (p === 'positionSticky')
	{
		elStyle.cssText = "position:sticky;position:-webkit-sticky;position:-ms-sticky;overflow:hidden;height:1px;width:1px;top:-1px;left:-1px";

		res = elStyle.position.indexOf('sticky') !== -1;
	}
	else */if(p === 'onorientationchange')
	{
		res = 'onorientationchange' in window;
	}
	else
	{
		res = false;
	}

	return res;
};

/**
 * Konstruktor
 *
 * @constructor
 * @since 1.0.0
 * @public
 *
 * @returns {object}
 */
Page = function() {
	'use strict';

	// Einstellungen speichern.
	this.settings = Page.DEFAULTS;

	// Übersetzungen speichern.
	this.translations = Page.TRANSLATIONS;

	// Feld von Funktionsaufrufen für Event `window.resize`.
	this.stackWindowResize = [];

	// Feld von Funktionsaufrufen für Event `window.scroll`.
	this.stackWindowScroll = [];

	// Elementreferenzen.
	this.$window     = $(window);
	this.$root       = document.documentElement;
	this.$html       = $('html');
	this.$doc        = $(document);
	this.$body       = $(document.body);
	this.$page       = $('#page');
	this.$pageNav    = $('#page-nav');
	this.$serviceNav = $('#service-nav');
	this.$pageHeader = $('#page-header');
	this.$pageFooter = $('#page-footer');

	this.supports = {
		'positionSticky'   : this.$html.hasClass('csspositionsticky'),
		'orientationchange': window.hasSupport('onorientationchange'),
		'loading'          : 'loading' in HTMLImageElement.prototype
	};

	// Sprache
	this.lang = this.$html.attr('lang');

	// kleiner Mobilcheck
	this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

	return this;/*{
		'init'              : this.init,
		'option'            : this.option,
		'translation'       : this.translation,
		'pushToWindowResize': this.pushToWindowResize,
		'isMsie'            : this.isMsie
	};*/
};

/**
 * Standardparameter.
 *
 * @constant {Object}
 */
Page.DEFAULTS = {
	/**
	 * Debugmodus.
	 *
	 * @type {Number}
	 */
	'debug': 0,

	/**
	 * Systempfade.
	 *
	 * @type {Object}
	 */
	'path': {
		'base'     : '',
		'resources': 'resources/'
	},

	/**
	 * Zeitverzögerungen in Millisekunden.
	 *
	 * @type {Object}
	 */
	'delay': {
		'windowScroll'  : 150,
		'windowResize'  : 250,
	},

	'breakpoints': {
		'xs'   : 420,
		's'    : 576,
		'm'    : 768,
		'ml'   : 992,
		'l'    : 1024,
		'xl'   : 1200,
		'xxl'  : 1400,
	},

	'google': {
		'map': {
			'latitude' : 51.346253,
			'library'  : '//maps.google.com/maps/api/js',
			'longitude': 12.370664,
			'marker'   : {
				'icons': {
					'primary'  : {
						'url'  : 'fileadmin/sys/Public/Shared/images/gmap/mrk-primary.png',
						// 'size' : new gm.Size(28, 40),
						// 'origin':new gm.Point(0, 0),
						// 'anchor':new gm.Point(0, 40)
						'shape': {
							'coord': [
								14, 2, 19, 3, 23, 6, 25, 9, 26, 14, 23, 23, 19,
								31, 15, 38, 13, 38, 9, 31, 5, 23, 2, 14, 3, 9,
								5, 6, 9, 3
							],
							'type' : 'poly'
						}
					},
					'secondary': {
						'url'  : 'fileadmin/sys/Public/Shared/images/gmap/mrk-secondary.png',
						// 'size' : new gm.Size(28, 40),
						// 'origin':new gm.Point(0, 0),
						// 'anchor':new gm.Point(0, 40)
						'shape': {
							'coord': [
								14, 2, 19, 3, 23, 6, 25, 9, 26, 14, 23, 23, 19,
								31, 15, 38, 13, 38, 9, 31, 5, 23, 2, 14, 3, 9,
								5, 6, 9, 3
							],
							'type' : 'poly'
						}
					},
					'tertiary' : {
						'url'  : 'fileadmin/sys/Public/Shared/images/gmap/mrk-tertiary.png',
						// 'size' : new gm.Size(28, 40),
						// 'origin':new gm.Point(0, 0),
						// 'anchor':new gm.Point(0, 40)
						'shape': {
							'coord': [
								14, 2, 19, 3, 23, 6, 25, 9, 26, 14, 23, 23, 19,
								31, 15, 38, 13, 38, 9, 31, 5, 23, 2, 14, 3, 9,
								5, 6, 9, 3
							],
							'type' : 'poly'
						}
					}
				}
			}
		}
	},

	/**
	 * Cookie consent.
	 *
	 * @type {Object}
	 */
	'cookieConsent': {
		'url' : '',
		'text': {
			'btnAccept' : 'accept',
			'btnDecline': 'decline',
			'info'      : '|a|Further informations about the use of cookies|/a|'
		}
	}
};

/**
 * Standardübersetzungen.
 *
 * @constant {Object}
 */
Page.TRANSLATIONS = {};

/**
 * ...
 */
Page.prototype.setupGeneral = function() {
	'use strict';

	var root = this;

	// Höhe des Seitenkopfes und Seitenfußes als Root-Variable aktualisieren.
	this.pushToWindowResize(function() {
		var hH = parseInt(root.$pageHeader.outerHeight(), 10),
			fH = parseInt(root.$pageFooter.outerHeight(), 10);

		root.rootVar('--header-height', hH + 'px');
		root.rootVar('--footer-height', fH + 'px');
	});

	// this.pageNav();

	// Page-Blocker initialisieren.
	// this.pageBlocker = new PageBlocker();

	// Cookiebar
	// this.cookiebar();

	// Button ´nach oben´
	this.topJump();

	// Textarea max length
	$('textarea[aria-describedby][maxlength]').not('[maxlength=""]').each(function() {
		var $this = $(this),
			m     = parseInt($this.attr('maxlength'), 10),
			$info = $('#' + $this.attr('aria-describedby')),
			msg   = (root.lang === 'de') ? 'Noch %s Zeichen übrig' : '%s characters left';

		if (m > 0 && $info.length > 0)
		{
			$this
				.data('defaultInfo', $info.html())
				.on(EVENT.KEYUP, function() {
					var c = parseInt($(this).val().length),
						r = m - c;

					$info.html(msg.replace("%s", r));
				})
				.on(EVENT.BLUR, function() {
					var c = parseInt($(this).val().length);

					if (c === 0)
					{
						$info.html($this.data('defaultInfo'));
					}
				});
		}
	});

	// Fancybox
/*	if (typeof $.fancybox !== 'undefined')
	{
		$.fancybox.defaults = $.extend(true, {}, $.fancybox.defaults, {
			'animationEffect'  : 'zoom-in-out',
			'transitionEffect' : 'zoom-in-out',
			'baseClass'        : 'fancybox-customized',
			'btnTpl'           : {
				'arrowLeft' : '<button data-fancybox-prev class="fancybox-button -prev" title="{{PREV}}"><i class="fal fa-angle-left"></i></button>',
				'arrowRight': '<button data-fancybox-next class="fancybox-button -next" title="{{NEXT}}"><i class="fal fa-angle-right"></i></button>',
				'close'     : '<button data-fancybox-close class="fancybox-button -close" title="{{CLOSE}}"><i class="fal fa-times"></i></button>',
				'smallBtn'  : '<button data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><i class="fal fa-times"></i></button>',
				'thumbs'    : '<button data-fancybox-thumbs class="fancybox-button -thumbs" title="{{THUMBS}}"><i class="fal fa-grip-horizontal"></i></button>',
				'zoom'      : '<button data-fancybox-zoom class="fancybox-button -zoom" title="{{ZOOM}}"><i class="fal fa-expand-arrows"></i></button>'
			},
			'image'            : {
				preload: true
			},
			'focus'            : false,
			'gutter'           : 32,
			'hash'             : false,
			'infobar'          : false,
			'smallBtn'         : true,
			'thumbs'           : {
				axis: 'x'
			}
		});

		$('[data-fancybox]:not([data-type="iframe"])').fancybox({
			'caption': function(instance, item) {
				var $this    = $(this),
					$caption = $this.closest('.figure').find('.figure__caption'),
					r        = '';

				if ($caption.length > 0)
				{
					r = $caption.clone();//html();
				}

				return r;
			}
		});

		$('[data-fancybox][data-type="iframe"]').fancybox({
			'caption'     : function() {
				return '';
			},
			'clickSlide'  : false,
			'clickOutside': false,
			'toolbar'     : false
		});

		$('[data-overlay-form]').fancybox({
			'baseClass'   : 'fancybox-customized -overlay-form',
			'caption'     : function() {
				return '';
			},
			'clickSlide'  : false,
			'clickOutside': false,
			'toolbar'     : false,
			'type'        : 'iframe',
			'beforeShow' : function(instance) {
				$(document).on('keyup.overlayFormContact', function(ev) {
					var k = ev.key || ev.keyCode;

					if (k === 'Escape' || k === 'esc' || k === 27)
					{
						instance.close();
					}
				});
			},
			'beforeClose' : function() {
				$(document).off('keyup.overlayFormContact');
			}
		});
	}*/

	// // Schliessen aus einem iframe heraus.
	// $('.main-modal-iframe-wrapper *[data-fb-custom="close"]').click(function(ev) {
	// 	ev.preventDefault();
	//
	// 	if (parent.jQuery)
	// 	{
	// 		parent.jQuery.fancybox.getInstance().close();
	// 	}
	// });
	//
	// settings.caption = function(instance, item) {
	// 	var $this = $(this),
	// 		r     = '';
	//
	// 	if (
	// 		item.type === 'image' &&
	// 		$this.closest('.c-figure').find('.c-figure__caption').length > 0
	// 	) {
	// 		r = $this.closest('.c-figure').find('.c-figure__caption').html();
	// 	}
	//
	// 	return r;
	// };
	//
	// settings.onComplete = function(instance, slide) {
	// 	slide.$slide.find('[data-fb-custom="close"]').click(function(ev) {
	// 		ev.preventDefault();
	//
	// 		instance.close();
	// 	});
	// };
	//
	// $group.fancybox(settings);

	this.pageSearch();
	this.accordion();
	this.tab();
	this.video();
	this.slider();
	this.ajaxContent();
	this.formValidate();
	this.formAutoSubmit();
	this.formClearableFields();

	// Autofocus (nur Desktop)
	if (!this.isMobile)
	{
		$('[autofocus]', this.$body).eq(0).trigger(EVENT.FOCUS);
	}

	// this.formFloatingLabel();

	// ´Leerbare´ Formularfelder.


	// this.datepicker();



	// TODO(JS): Tooltips aktivieren?!
	// Tooltips
	// if (!this.isMobile)
	// {
	// 	$('[data-toggle="tooltip"]').tooltip();
	// }

	this.checkElementsInView();
};

/**
 * Events
 */
Page.prototype.addListeners = function() {
	'use strict';

	var root        = this,
		timeoutWinS = null,
		timeoutWinR = null;

	// Event `window.scroll` (zeitverzögerte Ausführung)
	root.$window
		.on(EVENT.SCROLL, function() {
			clearTimeout(timeoutWinS);

			timeoutWinS = setTimeout(function() {
				var i = 0;

				// Gespeicherte Funktionsaufrufe aufrufen.
				for (; i < root.stackWindowScroll.length; i++)
				{
					root.stackWindowScroll[i]();
				}
			}, root.settings.delay.windowScroll);
		})
		.trigger(EVENT.SCROLL);

	// Event `window.resize` (zeitverzögerte Ausführung)
	root.$window
		.on(EVENT.RESIZE, function() {
			clearTimeout(timeoutWinR);

			timeoutWinR = setTimeout(function() {
				var i = 0;

				// Gespeicherte Funktionsaufrufe aufrufen.
				for (; i < root.stackWindowResize.length; i++)
				{
					root.stackWindowResize[i]();
				}
			}, root.settings.delay.windowResize);
		})
		.trigger(EVENT.RESIZE);

	// Globales Klick & KeyUp Event für `[data-trigger]`, triggert bei
	// Ausführung ein Event `general...` (siehe `EventNs`).
	$('[data-trigger]').on(EVENT.CLICK + '.trigger', function(ev) {
		ev.preventDefault();
		ev.stopPropagation();

		// Jeder Trigger bekommt im Vorfeld seine eigenen Funktionalitäten
		// zugewiesen inkl. eines Events `general...` (siehe `EventNs`).
		$(this).trigger(EVENT.GENERAL, ev);
	});

	// TODO: Print function nötig?
	// $('[data-print-page]').on(EVENT.CLICK, function(ev) {
	// 	ev.preventDefault();
	//
	// 	window.print();
	// });
};

/**
 * Seitenkopf, scroll, minimieren.
 */
Page.prototype.pageNav = function() {
	'use strict';

	var root            = this,
		$pageHeaderWrap = $('.page-header__wrap', this.$pageHeader).eq(0);

	this.$pageNav.on('checkDesktopFixedNav', function() {
		var winWidthOuter  = root.$window.outerWidth(),
			winWidth       = root.$window.width(),
			winScroll      = window.scrollY || window.pageYOffset,
			pageNavYOffset = parseInt(root.$pageNav.css('padding-top'), 10),
			hWW;

		if (winWidthOuter >= root.settings.breakpoints.l)
		{
			hWW = $pageHeaderWrap.outerWidth();

			root.$pageNav.css('right', (winWidth - hWW) / 2);

			if (winScroll > pageNavYOffset)
			{
				root.$pageNav.addClass('-keep-free');
			}
			else
			{
				root.$pageNav.removeClass('-keep-free');
			}
		}
		else
		{
			root.$pageNav.removeClass('-keep-free');
		}
	});

	window.onresize = function() {
		if(root.$window.width() >= root.settings.breakpoints.l)
		{
			root.$pageNav.trigger('checkDesktopFixedNav');
		}
	};

	window.onscroll = function() {
		if(root.$window.width() >= root.settings.breakpoints.l)
		{
			root.$pageNav.trigger('checkDesktopFixedNav');
		}
	};
};

/**
 * Seitennavigation initialisieren.
 *
Page.prototype.panelNav = function() {
	var root = this,
		$b   = root.$pageHeader.find('.page-nav, .service-nav').clone(),
		$f   = root.$pageHeader.find('.c-language-toggle');

	this.panelNavApi = null;

	// Nur wenn eine Navigation auch da ist!
	if ($b.length > 0)
	{
		this.panelNavApi = new OverlayPanel('panel-nav', {
			'class'       : 'panel-nav',
			'header'      : {
				'close': true
			},
			'btnCloseText': '<i class="fal fa-times"></i>',
			'body'        : $b.clone(),
			'footer'      : (($f.length > 0) ? $f.clone() : false),
			'onComplete'  : function($o) {
				var $ul = $o.find('ul');

				$o
					.find('[id]')
						.removeAttr('id')
						.end()
					.find('a')
						.attr('rel', 'nofollow')
						.end();

				if ($ul.length > 0)
				{
					$ul.prev('a').on('click', function(ev, delay) {
						var $this   = $(this),
							$parent = $this.parent('li'),
							$ul     = $(this).next('ul');

						// Ein Klick auf Eintrag mit Untermenü öffnet Untermenü,
						// zweiter Klick springt zur URL!
						if (!$parent.hasClass('-opened'))
						{
							ev.preventDefault();

							$parent.addClass('-opened');
							$ul.slideDown(((typeof delay === 'undefined') ? 250 : delay));
						}

						// Ein Klick auf Eintrag mit Untermenü öffnet Untermenü,
						// zweiter Klick schließt Untermenü!
						// ev.preventDefault();
						//
						// if (!$parent.hasClass('-opened'))
						// {
						// 	$parent.addClass('-opened');
						// 	$ul.slideDown(((typeof delay === 'undefined') ? 250 : delay));
						// }
						// else
						// {
						// 	$parent.removeClass('-opened');
						//
						// 	$ul.slideUp(((typeof delay === 'undefined') ? 250 : delay));
						// }
					});

					// console.log($ul.parent('li.-active'));
					$ul.parent('li.-active').find('> a').trigger('click', [0]);
				}
			},
			'onShow'      : function() {
				root.pageBlocker.show();
			},
			'onHide'      : function() {
				root.pageBlocker.hide();
			}
		});
	}
};
 */

//
// Components
//

/**
 * Seitensuche initialisieren.
 */
Page.prototype.pageSearch = function() {
	'use strict';

	var root     = this,
		key      = 'page-search',
		$bar     = $('#' + key),
		$trigger = $('[data-trigger="' + key + '"]');

	if ($trigger && $bar)
	{
		// Suchbar-Events für ein-, ausblenden
		$bar
			.on(EVENT.SHOW + '.page-search', function() {
				// Status-CSS-Klasse dem HTML-Tag hinzufügen.
				root.$html.addClass('show-page-search');

				// Keyup-Event für ´Esc´ (Schließen) anbinden.
				root.$doc
					.on(EVENT.KEYUP + '.page-search', function(ev) {
						var k = ev.key;

						if (k === 'Escape' || k === 'esc' || parseInt(k, 10) === 27)
						{
							$bar.trigger(EVENT.HIDE + '.page-search');
						}
					});
			})
			.on(EVENT.HIDE + '.page-search', function() {
				// Status-CSS-Klasse vom HTML-Tag entfernen.
				root.$html.removeClass('show-page-search');

				// Keyup-Event für ´Esc´ (Schließen) wieder entfernen.
				$(document).off(EVENT.KEYUP + '.page-search');
			});

		// Suchbar-Trigger-Events
		$trigger
			.on(EVENT.GENERAL, function(ev) {
				var cmd = (root.$html.hasClass('show-page-search')) ? 'HIDE' : 'SHOW';

				ev.preventDefault();

				$bar.trigger(EVENT[cmd] + '.page-search');
			});

		// ´Outsideclick´ für das Schließen der Suchbar, Klick außerhalb der
		// geöffneten Suchbar, aktivieren.
		this.addOutsideClick(null, $bar, {
			'evNamespace': 'page-search',
			'cb'         : function() {
				if (root.$html.hasClass('show-page-search'))
				{
					$bar.trigger(EVENT.HIDE + '.page-search');
				}
			}
		});
	}
};

/**
 * Ajax content.
 *
 * @example
 * Page.ajaxContent();
 * Page.ajaxContent('.container');
 *
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach entspr. Elemtenten gesucht wird.
 */
Page.prototype.ajaxContent = function(m) {
	'use strict';

	var root        = this,
		$collection = this.getElementsByContext('[data-ajax-content]', m);

	$collection.each(function() {
		var $container = $(this),
			context    = '#' + $container.attr('data-ajax-content');

		$container
			.on('getData' + EVENT_KEY, function(ev, url, context) {
				if (!$container.data('loading') && url && context)
				{
					$container
						.data('loading', true)
						.removeClass('-is-loaded')
						.addClass('-is-waiting');

					$.ajax({
						'url'     : url,
						'type'    : 'GET',
						'dataType': 'html',
						'success' : function(r) {
							var $r = $('<div>').append($.parseHTML(r)).find(context);

							$container
								.data('loading', false)
								.removeClass('-is-waiting')
								.addClass('-is-loaded')
								.html($r.html());

							window.setTimeout(function() {
								root.scrollWindowTo($container);
							}, 350);
						}// ,
						// 'error': function() {}
					});
				}
			})
			.on(EVENT.CLICK, 'a[data-ajax-link], .pagination__link', function(ev) {
				var $link = $(this);

				ev.preventDefault();

				$container.trigger('getData' + EVENT_KEY, [$link.attr('href'), context]);
			});
	});
};

/**
 * Accordion.
 *
 * @example
 * Page.accordion();
 * Page.accordion('.container');
 *
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach entspr. Elemtenten gesucht wird.
 */
Page.prototype.accordion = function(m) {
	'use strict';

	var root        = this,
		$collection = this.getElementsByContext('[data-accordion] > .accordion__panel', m);

	// Scroll to active toggle.
	$collection.on('show.bs.collapse', function(ev) {
		var $t = $('#' + $(ev.currentTarget).attr('aria-labelledby'));

		window.setTimeout(function() {
			root.scrollWindowTo($t);
		}, 500);
	});
};

/**
 * Tab.
 *
 * @example
 * Page.tab();
 * Page.tab('.container');
 *
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach entspr. Elemtenten gesucht wird.
 */
Page.prototype.tab = function(m) {
	'use strict';

	var root        = this,
		$collection = this.getElementsByContext('[data-toggle="tab"]', m);

	// Scroll to active toggle.
	$collection.on('shown.bs.tab', function(ev) {
		var $t = $(ev.currentTarget);

		window.setTimeout(function() {
			root.scrollWindowTo($t);
		}, 500);
	});
};

/**
 * Slider.
 *
 * @example
 * Page.slider();
 * Page.slider('.container');
 *
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach entspr. Elemtenten gesucht wird.
 */
Page.prototype.slider = function(m) {
	'use strict';

	var root     = this,
		a11y     = root.translation('slider'),
		selector = '[data-c="slider"]',
		defaults = {
			'a11y'                 : {
				'firstSlideMessage'      : a11y.first || 'first item',
				'lastSlideMessage'       : a11y.last || 'last item',
				'nextSlideMessage'       : a11y.next || 'next item',
				'paginationBulletMessage': a11y.goTo || 'got to {{index}}',
				'prevSlideMessage'       : a11y.prev || 'previous item'
			},
			'autoHeight'           : true,
			'spaceBetween'         : 16,
			'breakpoints'          : {
				'420': {
					'spaceBetween': 32
					// 'slidesPerView': 2
				}/*,
				'768': {
					'spaceBetween': 32
					// 'slidesPerView': 2
				},
				'992': {
					'spaceBetween': 32
					// 'slidesPerView': 2
				}*/
			},
			'navigation'           : {
				'hideOnClick': true
			},
			'pagination'           : {
				'clickable'     : true,
				'el'            : null,
				'dynamicBullets': true
				// 'type'             : 'fraction',
				// 'renderBullet'     : function(idx, cN) {
				// 	return '<span class="' + cN + '">' + (idx + 1) + '</span>';
				// }
			},
			'slidesPerView'        : 1,
			'watchSlidesVisibility': true
		},
		$group   = $(selector);

	// Elemente suchen.
	if (typeof m !== 'undefined' && $(m).length > 0)
	{
		$group = $(m).find(selector);
	}

	$group
		.on(EVENT.IN + '.viewport', function() {
			var $this  = $(this),
				params = defaults,
				api;

			if (!$this.data('slider' + EVENT_KEY + DATA_API_KEY))
			{
				// Buttons anbinden?
				params.navigation.nextEl = $('.swiper-button-next', $this) || null;
				params.navigation.prevEl = $('.swiper-button-prev', $this) || null;

				// Pagination anbinden?
				params.pagination.el = $('.swiper-pagination', $this) || null;

				api = new Swiper($('.swiper-container', $this).eq(0), params);

				$this
					.data('slider' + EVENT_KEY + DATA_API_KEY, api)
					.addClass('-is-initialized');

				// Force dimension 4 Firefox-Rendering Issues.
				root.pushToWindowResize(function() {
					$this.data('slider' + EVENT_KEY + DATA_API_KEY).update();
				});
			}
		})
		// .on(EVENT.OUT + '.viewport', function() {})
		// Wird bei einem Slider kein ´in viewport´ eingesetzt, dann sollte er
		// sofort initialisiert werden!
		.each(function() {
			var $this = $(this);

			if (typeof $this.attr('data-viewport') === 'undefined')
			{
				$this.trigger(EVENT.IN + '.viewport');
			}
		});
};

/**
 * Slider.
 *
 * @example
 * Page.video();
 * Page.video('.container');
 *
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach entspr. Elementen gesucht wird.
 */
Page.prototype.video = function(m) {
	'use strict';

	var root     = this,
		selector = '.video:not(data-privacy)',
		$group   = $(selector);

	// Elemente suchen.
	if (typeof m !== 'undefined' && $(m).length > 0)
	{
		$group = $(m).find(selector);
	}

	$group
		.on(EVENT.IN + '.viewport', function() {
			var $this = $(this),
				$iframe =  $('iframe', $this);

			if ($iframe && !$this.data('video' + EVENT_KEY + DATA_API_KEY))
			{
				$this
					.data('video' + EVENT_KEY + DATA_API_KEY, {
						'dataSrc': $iframe.attr('data-src'),
						'iframe' : $iframe
					})
					.addClass('-is-initialized');

				$this.data('video' + EVENT_KEY + DATA_API_KEY).iframe.attr(
					'src',
					$this.data('video' + EVENT_KEY + DATA_API_KEY).dataSrc
				);
			}
		})
		.on(EVENT.OUT + '.viewport', function() {
			var $this = $(this);

			if ($this.data('video' + EVENT_KEY + DATA_API_KEY))
			{
				// Durch erneutes Setzen von `src` im `iframe` wird ein Video
				// automatisch gestoppt.
				$this.data('video' + EVENT_KEY + DATA_API_KEY).iframe.attr(
					'src',
					$this.data('video' + EVENT_KEY + DATA_API_KEY).dataSrc
				);
			}
		})
		// Wird bei einem Video kein ´in viewport´ eingesetzt, dann sollte es
		// sofort initialisiert werden!
		.each(function() {
			var $this = $(this);

			if (typeof $this.attr('data-viewport') === 'undefined')
			{
				$this.trigger(EVENT.IN + '.viewport');
			}
		});
};

/**
 * Validierungsfunktion für Formulare
 *
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach entspr. Elemtenten gesucht wird.
 */
Page.prototype.formValidate = function(m) {
	'use strict';

	var root        = this,
		$collection = this.getElementsByContext('form[data-validate]', m);

	$collection.each(function() {
		var $form = $(this);

		$form.on(EVENT.SUBMIT, function(ev) {
			var $firstInvalid;

			if ($form[0].checkValidity() === false)
			{
				ev.preventDefault();
				ev.stopPropagation();

				$firstInvalid = $form.find('.form-control:invalid').eq(0);

				if ($firstInvalid)
				{
					// TODO: scroll to `.form-control:invalid` auf Basis von `scrollWindowTo(el)` aktualisieren!
					window.setTimeout(function() {
						$('html, body').animate({
							'scrollTop': $firstInvalid.offset().top - root.$pageHeader.outerHeight()
						}, 250);
					}, 500);
				}
			}

			$form.addClass('was-validated');

			// return false;
		});
	});
};

/**
 * Autosubmit von Formularen durch Formularelemente auslösen.
 *
 * @example
 * Page.formAutoSubmit();
 * Page.formAutoSubmit('.container');
 *
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach entspr. Elementen gesucht wird.
 */
Page.prototype.formAutoSubmit = function(m, o) {
	'use strict';

	var settings = $.extend({
			'onBeforeSubmit': function() {
			}
		}),
		fcCall   = function() {
			$(this).closest('form').submit();
		};

	this.getElementsByContext('[data-form-autosubmit]:not(select)', m).on(EVENT.CLICK + '.autosubmit', fcCall);

	this.getElementsByContext('select[data-form-autosubmit]', m).on(EVENT.CHANGE + '.autosubmit', fcCall);
};

/**
 * Texteingabefelder (Input) per Button ´leeren´.
 *
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach entspr. Elemtenten gesucht wird.
 * @param {Object}          [o] - Optionen.
 */
Page.prototype.formClearableFields = function(m, o) {
	'use strict';

	var sFields       = 'input[type="text"][data-clearable], input[type="search"][data-clearable], input[type="number"][data-clearable], input[type="email"][data-clearable]',
		sTrigger      = '[data-clearable-trigger]',
		$formElements = this.getElementsByContext(sFields, m);

	$formElements
		.wrap('<div class="form-control-clearable"/>')
		.after('<button type="button" data-clearable-trigger tabindex="-1" aria-hidden="true"><i class="fal fa-times"></i></button>')
		.on('input change propertychange clearable.change', function() {
			var $this   = $(this),
				visible = ($this.val() !== '');

			$this.siblings(sTrigger).toggleClass('hidden', !visible);
		})
		.trigger('propertychange');

	this.$doc.on(EVENT.CLICK, sTrigger, function(ev) {
		$(this)
			.siblings(sFields).val('')
			.trigger('propertychange');
		// .focus();
	});
};

//
// Tools
//

/**
 * Prüfe auf Elemente ´in View´.
 */
Page.prototype.checkElementsInView = function() {
	'use strict';

	var timeout = null,
		root    = this,
		$group = $('[data-viewport]');

	if ($group.length > 0)
	{
		$group.append($('<span data-viewport-layer/>'));

		// Event `window.scroll` (zeitverzögerte Ausführung)
		this.$window.on(EVENT.SCROLL + '.viewport ' + EVENT.RESIZE + '.viewport', function() {
			clearTimeout(timeout);

			timeout = setTimeout(function() {
				$group.each(function() {
					var $el = $(this);

					if ($el.inViewport())
					{
						$el
							.attr('data-viewport', 'in')
							.trigger(EVENT.IN + '.viewport');
					}
					else
					{
						$el
							.attr('data-viewport', 'out')
							.trigger(EVENT.OUT + '.viewport');
					}
				});

			}, root.settings.delay.windowScroll);
		})
		.trigger(EVENT.SCROLL + '.viewport');
	}
};

/**
 * ´Outside click´ anbinden.
 *
 * @param {(String/Object)} [elBase=body] - geklicktes Element was den ´Outside click´ überwacht (Selektor oder jQuery-DOM-Element).
 * @param {(String/Object)} elObserve - Selektor oder jQuery-DOM-Element.
 * @param {Object} [o] - Einstellungen
 */
Page.prototype.addOutsideClick = function(elBase, elObserve, o) {
	'use strict';

	var settings   = $.extend(true, {}, {
			'evNamespace': '',
			'cb'         : null
		}, o || {}),
		$elBase    = (!elBase) ? this.$body : $(elBase),
		$elObserve = (elObserve) ? $(elObserve) : null,
		useEvType  = EVENT.CLICK + '.outside' + ((settings.evNamespace !=='') ? '.' + settings.evNamespace : '');

	if ($elObserve && typeof settings.cb === 'function')
	{
		$elBase.on(useEvType, function(ev) {
			var $evTarget = $(ev.target);

			if (
				!$elObserve.is($evTarget) &&
				$elObserve.has($evTarget).length <= 0
			) {
				settings.cb.apply(ev, [ev, $evTarget, $elObserve]);
			}
		});
	}
};

/**
 * ScrollTop einbinden.
 */
Page.prototype.topJump = function() {
	'use strict';

	var root     = this,
		$baseTop = $('[data-to-top="base"]');

	this.$doc.on(EVENT.CLICK, '[data-to-top]', function(ev) {
		root.scrollWindowTo(null);
	});

	if ($baseTop.length)
	{
		$baseTop
			.on(EVENT.SHOW, function() {
				$(this).fadeIn(500);
			})
			.on(EVENT.HIDE, function() {
				$(this).fadeOut(250);
			});

		this.pushToWindowScroll(function() {
			var wIH = 0.75 * window.innerHeight;

			$baseTop.trigger(EVENT[((window.scrollY >= wIH) ? 'SHOW' : 'HIDE')]);
		});
	}
};

//
// Helpers
//

/**
 * Elemente holen.
 *
 * @example
 * Page.getElementsByContext('a'); // alle `<a/>` im Dokument
 * Page.getElementsByContext('a', '.container'); // alle `<a/>` in `<div class="container"/>`
 *
 * @param {String} s - Selektor
 * @param {(Object|String)} [m=body] - jQuery-DOM-Element oder Klassen-(Id-)Selektor in dem nach `s` gesucht wird.
 *
 * @returns {Object}
 */
Page.prototype.getElementsByContext = function(s, m) {
	'use strict';

	return ((typeof m !== 'undefined' && $(m).length > 0) ? $(m).eq(0).find(s) : $(s));
};

/**
 * Auslesen und Bereitstellen einer Javascript-JSON-Konfiguration die per
 * `<script type="application/json" data-config/>` im HTML integriert ist.
 * Nach dem Auslesen wird `<script .../>` entfernt.
 *
 * @param {Object} el - jQuery-DOM-Element (Component-Container).
 * @param {String} t - Kontext für den Selektor `[data-config-(t)].
 *
 * @returns {Object}
 */
Page.prototype.getInlineConfig = function(el, t) {
	'use strict';

	var cfg  = {},
		s    = (t !== 'undefined' && t !== '') ? 'data-config="' + t + '"' : 'data-config',
		$cfg = el.find('> script[type="application/json"][' + s + ']').eq(0);

	if ($cfg.length > 0)
	{
		cfg = JSON.parse($cfg.text()) || {};

		$cfg.remove();
	}

	return cfg;
};

/**
 * Schreiben/lesen von Einstellungen in `settings`.
 *
 * @param {String|Object} key - Schlüssel des Eintrages oder ein Objekt mit Zuweisungen `{key: val, ...}`.
 * @param {*} val
 *
 * @access public
 */
Page.prototype.option = function(key, val) {
	'use strict';

	if (val && typeof key === 'string')
	{
		// einzelene Einstellung speichern
		this.settings[key] = val;
	}
	else
	{
		if (typeof key === 'object' && !Array.isArray(key))
		{
			// mehrere Einstellungen speichern
			this.settings = $.extend(true, this.settings, key);
		}
		else if (typeof key === 'string')
		{
			// Wert zurückgeben
			return this.settings[key];
		}
	}
};

/**
 * Schreiben/lesen von Übersetzungen in `translations`.
 *
 * @param {String|Object} key - Schlüssel des Eintrages oder ein Objekt mit Zuweisungen `{key: val, ...}`.
 * @param {*} val
 *
 * @access public
 */
Page.prototype.translation = function(key, val) {
	'use strict';

	if (val && typeof key === 'string')
	{
		// einzelene Übersetzung speichern
		this.translations[key] = val;
	}
	else
	{
		if (typeof key === 'object' && !Array.isArray(key))
		{
			// mehrere Übersetzung speichern
			this.translations = $.extend(true, this.translations, key);
		}
		else if (typeof key === 'string')
		{
			// Übersetzung zurückgeben
			return this.translations[key];
		}
	}
};

/**
 * Scroll window to.
 *
 * @param {(String/Object)} [el] - Zielelement, Standard ist Seitenanfang.
 * @param {Number} offset - Offset der von der Y-Zielposition abgezogen wird.
 */
Page.prototype.scrollWindowTo = function(el, offset) {
	'use strict';

	var root          = this,
		yTo           = 0,
		yFrom         = document.documentElement.scrollTop || document.body.scrollTop,
		// winWidthOuter = root.$window.outerWidth(),
		winHeight     = window.innerHeight,
		delay         = 500,
		diff          = Math.abs(yFrom - yTo),
		elOffset;

	// Wenn Element vorhanden, dann oberste Elementposition (Y) holen.
	if (el && $(el).length > 0)
	{
		yTo  = $(el).offset().top;
		diff = Math.abs(yFrom - yTo);
	}

	//
	// Scrollgeschwindigkeit bestimmen.
	//

	if (diff > winHeight * 3)
	{
		delay = 250;
	}
	else if (diff > winHeight * 2)
	{
		delay = 300;
	}
	else if (diff > winHeight * 1.25)
	{
		delay = 400;
	}

	//
	// Y-Koordinatenbestimmen
	//

	// Parameter `offset` oder Elementeigenschaft `scroll-margin-top` beachten.
	if (offset)
	{
		elOffset = parseInt(offset, 10);
	}
	else if ($(el).length > 0)
	{
		elOffset = parseInt(getComputedStyle($(el)[0]).scrollMarginTop || 0, 10);
	}

	if(yTo > elOffset)
	{
		// Wenn Ziel-Y größer als Offset, dann ziehe Offset von Y ab.
		yTo -= elOffset;
	}
	else
	{
		// Setze Y = 0.
		yTo = 0;
	}

	//
	// Scroll...
	//

	$('html, body').animate({
		'scrollTop': yTo
	}, delay);
};

/**
 * Root-Variablen auslesen und/oder setzen.
 *
 * @example
 * rootVar('--foo', 'bar'); // returns true
 * rootVar('--foo'); // returns 'bar'
 * rootVar('--not-exist'); // returns ''
 * rootVar(); // returns false
 *
 * @param {String} key - Name der Rootvariable (`--example`)
 * @param {String} val - Wert der Rootvariable
 *
 * @returns {(boolean|String)}
 */
Page.prototype.rootVar = function(key, val) {
	'use strict';

	var res = false,
		gCS;

	if (key)
	{
		if (typeof val !== 'undefined')
		{
			// Root-Variable setzen/aktualisieren.
			this.$root.style.setProperty(key, val);

			res = true;
		}
		else
		{
			gCS = getComputedStyle(this.$root);
			res = gCS.getPropertyValue(key);
		}
	}

	return res;
};

/**
 * Funktionen für das Event 'window.resize' speichern.
 *
 * @param {Function} f - Zu speichernder Funktionsaufruf.
 *
 * @version 1.0.0
 * @since 1.0.0
 * @access public
 */
Page.prototype.pushToWindowResize = function(f) {
	'use strict';

	if (typeof f === 'function')
	{
		this.stackWindowResize.push(f);
	}
};

/**
 * Funktionen für das Event 'window.scroll' speichern.
 *
 * @param {Function} f - Zu speichernder Funktionsaufruf.
 */
Page.prototype.pushToWindowScroll = function(f) {
	'use strict';

	if (typeof f === 'function')
	{
		this.stackWindowScroll.push(f);
	}
};

/**
 * Kleine MsIe-Browserprüfung.
 *
 * Rückgabe von 'false' oder der Versionsnummer.
 *
 * @returns {*}
 */
Page.prototype.isMsie = function() {
	'use strict';

	var v = false,
		ua,
		re;

	if (
		navigator.appName === 'Microsoft Internet Explorer' ||
		navigator.appName === 'Netscape'
	) {
		ua = navigator.userAgent;
		re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

		if (re.exec(ua) !== null)
		{
			v = parseFloat(RegExp.$1);
		}
		else if (!!navigator.userAgent.match(/Trident.*rv\:11\./))
		{
			// IE 11
			v = 11;
		}
	}

	return v;
};

/**
 * Initialisierung
 */
Page.prototype.init = function() {
	'use strict';

	this.isMsie = this.isMsie();

	this.setupGeneral();

	this.addListeners();
};

//
// Init
//

$(function() {
	'use strict';

	PageInstance = new Page();

	// Einstellungen aktualisieren/speichern.
	PageInstance.option(PageConf || {});

	// Einstellungen aktualisieren/speichern.
	PageInstance.translation(PageTranslations || {});

	// Seiteninstanz starten.
	PageInstance.init();
});
